import React, { Component } from 'react';
import DriversTable from './DriversTable';
import { m } from '../../utils';

class Drivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.props.retrieveSchedule();
  }

  componentWillReceiveProps(nextProps) {
    this.getTodaysBookings(nextProps.cars);
  }

  getTodaysBookings = (cars = []) => {
    const data = cars.map(car => {
      const todaysBookings = this.filterToday(car.bookings);
      const prevBooking = this.findPrevious(todaysBookings);
      const currentBooking = this.findCurrent(todaysBookings);
      return {
        plate: car.plate,
        prevBooking,
        currentBooking,
      };
    });
    this.setState({ data });
  };

  filterToday = bookings =>
    bookings.filter(
      booking => m(booking.startTime).isSame(m(), 'day') || m(booking.startTime).isSame(m().subtract(1, 'day'), 'day')
    );

  findPrevious = bookings => {
    const currentTime = m();
    let previousShift;

    if (currentTime.isSameOrAfter(m().hour('22'))) {
      // after 11 pm today?
      previousShift = m().hour('15');
    } else if (currentTime.isSameOrAfter(m().hour('14'))) {
      // afer 3 pm today?
      previousShift = m().hour('7');
    } else if (currentTime.isSameOrAfter(m().hour('6'))) {
      // after 7 am today?
      previousShift = m()
        .hour('23')
        .subtract(1, 'day');
    } else if (currentTime.isBefore(m().hour('6'))) {
      // after 11 pm yesterday?
      previousShift = m()
        .hour('15')
        .subtract(1, 'day');
    } else {
      previousShift = null;
    }

    const prevBooking = bookings.filter(booking => m(booking.startTime).isSame(previousShift, 'hour'));

    return prevBooking.length ? prevBooking[0] : null;
  };

  findCurrent = bookings => {
    const currentTime = m();
    let currentShift;

    if (currentTime.isBefore(m().hour('6'))) {
      // before 7 am today?
      currentShift = m()
        .hour('23')
        .subtract(1, 'day');
    } else if (currentTime.isBefore(m().hour('14'))) {
      // before 3 pm today?
      currentShift = m().hour('7');
    } else if (currentTime.isBefore(m().hour('22'))) {
      // before 11 pm today?
      currentShift = m().hour('15');
    } else if (currentTime.isSameOrAfter(m().hour('22'))) {
      // after 11 pm today?
      currentShift = m().hour('23');
    } else {
      currentShift = null;
    }
    const currentBooking = bookings.filter(booking => m(booking.startTime).isSame(currentShift, 'hour'));

    return currentBooking.length ? currentBooking[0] : null;
  };

  render() {
    const { data } = this.state;
    const { searchTerm } = this.props;
    return (
      <div>
        <DriversTable data={data} openParkingDialog={this.props.openParkingDialog} searchTerm={searchTerm} />
      </div>
    );
  }
}

export default Drivers;

/*

PREVIOUS:
0 - 7: yesterday's 3 pm
7 - 15: yesterday's 11 pm
15 - 23: today's 7 am
23 - 24: today's 3 pm

CURRENT:
0 - 7: yesterday's 11 pm
7 - 15: today's 7 am
15 - 23: today's 3 pm
23 - 24: today's 11 pm

*/



// WEBPACK FOOTER //
// ./src/components/Parking/Drivers.js